import React from 'react';
import { createUseStyles } from 'react-jss';

import { FEATURES } from '../../../constants';
import Categories from './categories';
import Tags from './tags';
import ZoomLevel from './zoom-level';

const useStyles = createUseStyles({
  groups: {
    composes: ['mt24', 'flex-columns', 'flex-wrap', 'px6'],
  },
});

const MenuCategoriesComponent = React.memo(() => {
  const classes = useStyles();
  return (
    <div className="px6">
      <Categories />
      <div className={classes.groups}>
        {FEATURES.clusters_by_zoom && <ZoomLevel />}
        <Tags />
      </div>
    </div>
  );
});

MenuCategoriesComponent.displayName = 'MenuCategoriesComponent';

export default MenuCategoriesComponent;
